import React, { useState } from "react";
import { Fab, Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { keyframes } from "@emotion/react";
import { useTranslation } from "react-i18next";
import { WhatsApp } from "@mui/icons-material";

// Define the popping animation
const popAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
`;

const FloatingReferButton = ({ user }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [isClicked, setIsClicked] = useState(false);

  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => {
      setIsClicked(false);
      if (user) {
        const referralCode = user.user_profile.active_referral_code
        const message = `Hi👋\n\nWelcome to *Optimo Capital*, for all your loan needs!\n\nYou are referred by ${user.user_profile.first_name} ${user.user_profile.last_name}.\n\nClick on this link and apply now - ${user.user_profile.referrals_made[0]?.invite_url}`;
        const encodedMessage = encodeURIComponent(message);
        let url = `https://api.whatsapp.com/send/?text=${encodedMessage}`
        window.open(url, '_blank')
      } else {
        navigate("/sign-in");
      }
    }, 100); // Duration should match animation duration
  };

  return user?.user_profile?.referrals_made[0]?.invite_url && (
    <Box
      sx={{
        position: "fixed",
        bottom: 20,
        right: 10,
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        textAlign: "center",
        // width: "160px",
        // height: "80px",
        borderRadius: "50%",
      }}
    >
      <Fab
        variant="extended"
        onClick={handleClick}
        sx={{
          boxShadow: "0px 0px 20px 2px rgba(0, 0, 0, 0.3)",
          p: 2,
          color: '#fff',
          backgroundColor: "#25d366",
          border: "3px solid #fff",
          animation: isClicked ? `${popAnimation} 0.1s ease` : "none",
          ':hover': {
            color: '#fff',
            backgroundColor: "#25d366dd",
            border: "3px solid #fff",
            boxShadow: "0px 0px 30px 2px rgba(0, 0, 0, 0.3)",
          },
        }}
      >
        <WhatsApp sx={{ mr: 1 }} />
        <Typography
          variant="caption"
          sx={{
            fontWeight: "bold",
            // color: "grey",
          }}
        >
          {t('user_profile.refer_and_earn')}
        </Typography>
      </Fab>
    </Box>
  );
};

export default FloatingReferButton;
